const BASE_WARRANTY_YEARS = 2;

export const isGaranVisible = (warrantyYears: number | null): warrantyYears is number =>
    warrantyYears !== null && warrantyYears !== BASE_WARRANTY_YEARS;
